import "./sectionDivider.style.scss";

interface SectionDividerProps {
    className?: string;
}

export const SectionDivider = (props: SectionDividerProps) => {
    return (
        <div 
            className={`section-divider-wrap ${props?.className ? props.className : ""}`} 
            data-testid="section-divider-wrap"
        >
            <span className="line"/>
            <span className="circle"/>
            <span className="line"/>
        </div>
    )
}